"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustToWindow = exports.DynamicCapacityValuesOptions = exports.EndOfWeekDay = exports.GrabMode = exports.SmsProvider = exports.SharingMode = exports.ChainOfCustodyType = exports.TipType = exports.FormDisplayMode = exports.HourFormat = exports.FuturePeriod = void 0;
var FuturePeriod;
(function (FuturePeriod) {
    FuturePeriod[FuturePeriod["none"] = -1] = "none";
    FuturePeriod[FuturePeriod["today"] = 1] = "today";
    FuturePeriod[FuturePeriod["tomorrow"] = 2] = "tomorrow";
    FuturePeriod[FuturePeriod["next_24_hours"] = 3] = "next_24_hours";
    FuturePeriod[FuturePeriod["forever_and_ever"] = 4] = "forever_and_ever";
    FuturePeriod[FuturePeriod["custom"] = 5] = "custom";
    FuturePeriod[FuturePeriod["all_open_tasks"] = 6] = "all_open_tasks";
})(FuturePeriod || (exports.FuturePeriod = FuturePeriod = {}));
var HourFormat;
(function (HourFormat) {
    HourFormat[HourFormat["Default"] = 0] = "Default";
    HourFormat[HourFormat["TwelveHours"] = 1] = "TwelveHours";
    HourFormat[HourFormat["TwentyFourHours"] = 2] = "TwentyFourHours";
})(HourFormat || (exports.HourFormat = HourFormat = {}));
var FormDisplayMode;
(function (FormDisplayMode) {
    FormDisplayMode[FormDisplayMode["MANUAL"] = 0] = "MANUAL";
    FormDisplayMode[FormDisplayMode["AFTER_CHECK_IN"] = 1] = "AFTER_CHECK_IN";
    FormDisplayMode[FormDisplayMode["BEFORE_CHECKOUT"] = 2] = "BEFORE_CHECKOUT";
})(FormDisplayMode || (exports.FormDisplayMode = FormDisplayMode = {}));
var TipType;
(function (TipType) {
    TipType[TipType["PERCENT"] = 0] = "PERCENT";
    TipType[TipType["MONEY"] = 1] = "MONEY";
})(TipType || (exports.TipType = TipType = {}));
var ChainOfCustodyType;
(function (ChainOfCustodyType) {
    ChainOfCustodyType[ChainOfCustodyType["WEAK"] = 0] = "WEAK";
    ChainOfCustodyType[ChainOfCustodyType["STRONG"] = 1] = "STRONG";
    ChainOfCustodyType[ChainOfCustodyType["NONE"] = 2] = "NONE";
    ChainOfCustodyType[ChainOfCustodyType["UNLOAD"] = 3] = "UNLOAD";
})(ChainOfCustodyType || (exports.ChainOfCustodyType = ChainOfCustodyType = {}));
var SharingMode;
(function (SharingMode) {
    SharingMode[SharingMode["ALL"] = 0] = "ALL";
    SharingMode[SharingMode["EMAIL_ONLY"] = 1] = "EMAIL_ONLY";
    SharingMode[SharingMode["PHONE_ONLY"] = 2] = "PHONE_ONLY";
    SharingMode[SharingMode["NO_SHARING"] = 3] = "NO_SHARING";
    SharingMode[SharingMode["WEBHOOKS_ONLY"] = 4] = "WEBHOOKS_ONLY";
})(SharingMode || (exports.SharingMode = SharingMode = {}));
var SmsProvider;
(function (SmsProvider) {
    SmsProvider[SmsProvider["Twilio"] = 0] = "Twilio";
    SmsProvider[SmsProvider["Nexmo"] = 1] = "Nexmo";
})(SmsProvider || (exports.SmsProvider = SmsProvider = {}));
var GrabMode;
(function (GrabMode) {
    GrabMode[GrabMode["OFF"] = 0] = "OFF";
    GrabMode[GrabMode["AUTOMATIC"] = 1] = "AUTOMATIC";
    GrabMode[GrabMode["ON_DEMAND"] = 2] = "ON_DEMAND";
})(GrabMode || (exports.GrabMode = GrabMode = {}));
var EndOfWeekDay;
(function (EndOfWeekDay) {
    EndOfWeekDay[EndOfWeekDay["Friday"] = 0] = "Friday";
    EndOfWeekDay[EndOfWeekDay["Saturday"] = 1] = "Saturday";
    EndOfWeekDay[EndOfWeekDay["Sunday"] = 2] = "Sunday";
    EndOfWeekDay[EndOfWeekDay["Monday"] = 3] = "Monday";
    EndOfWeekDay[EndOfWeekDay["Tuesday"] = 4] = "Tuesday";
    EndOfWeekDay[EndOfWeekDay["Wednesday"] = 5] = "Wednesday";
    EndOfWeekDay[EndOfWeekDay["Thursday"] = 6] = "Thursday";
})(EndOfWeekDay || (exports.EndOfWeekDay = EndOfWeekDay = {}));
var DynamicCapacityValuesOptions;
(function (DynamicCapacityValuesOptions) {
    DynamicCapacityValuesOptions[DynamicCapacityValuesOptions["OFF"] = 0] = "OFF";
    DynamicCapacityValuesOptions[DynamicCapacityValuesOptions["ALL"] = 1] = "ALL";
    DynamicCapacityValuesOptions[DynamicCapacityValuesOptions["CURRENT_LOAD"] = 2] = "CURRENT_LOAD";
    DynamicCapacityValuesOptions[DynamicCapacityValuesOptions["EXPECTED_PICKUP"] = 3] = "EXPECTED_PICKUP";
})(DynamicCapacityValuesOptions || (exports.DynamicCapacityValuesOptions = DynamicCapacityValuesOptions = {}));
var AdjustToWindow;
(function (AdjustToWindow) {
    AdjustToWindow[AdjustToWindow["DEFAULT"] = 0] = "DEFAULT";
    AdjustToWindow[AdjustToWindow["BEGINNING"] = 1] = "BEGINNING";
    AdjustToWindow[AdjustToWindow["MIDDLE"] = 2] = "MIDDLE";
    AdjustToWindow[AdjustToWindow["ENDING"] = 3] = "ENDING";
})(AdjustToWindow || (exports.AdjustToWindow = AdjustToWindow = {}));
//# sourceMappingURL=merchant_configuration.js.map